export default function TermsPage() {
	return (
		<div className="container mx-auto max-w-3xl px-4 py-16">
			<h1 className="mb-8 text-3xl font-bold text-slate-900">
				Conditions d'utilisation
			</h1>
			<p className="mb-6 text-sm text-slate-500">
				Dernière mise à jour : 3 mars 2026
			</p>

			<div className="prose prose-slate max-w-none">
				<h2>1. Acceptation des conditions</h2>
				<p>
					En accédant ou en utilisant Vigilio (le « Service »),
					exploité par Themelio Inc. (« nous »), vous acceptez
					d'être lié par les présentes conditions d'utilisation. Si
					vous n'acceptez pas ces conditions, veuillez ne pas
					utiliser le Service.
				</p>

				<h2>2. Description du Service</h2>
				<p>
					Vigilio est une plateforme de veille médiatique qui
					agrège des sources d'actualités francophones québécoises,
					permet de créer des alertes basées sur des requêtes
					booléennes et de distribuer automatiquement les articles
					pertinents par courriel.
				</p>

				<h2>3. Inscription et compte</h2>
				<ul>
					<li>
						Vous devez fournir des informations exactes lors de
						l'inscription
					</li>
					<li>
						Vous êtes responsable de la confidentialité de vos
						identifiants
					</li>
					<li>
						Un compte correspond à une organisation; le
						propriétaire du compte est responsable de l'usage fait
						par les membres de son organisation
					</li>
				</ul>

				<h2>4. Utilisation acceptable</h2>
				<p>Vous vous engagez à ne pas :</p>
				<ul>
					<li>
						Utiliser le Service à des fins illégales ou non
						autorisées
					</li>
					<li>
						Tenter d'accéder aux données d'autres organisations
					</li>
					<li>
						Reproduire, redistribuer ou revendre le contenu agrégé
						à des fins commerciales sans autorisation
					</li>
					<li>
						Contourner les mesures de sécurité ou les limites de
						votre plan
					</li>
					<li>
						Envoyer des communications non sollicitées via les
						listes de distribution
					</li>
				</ul>

				<h2>5. Propriété intellectuelle</h2>
				<p>
					Le Service, son code, son design et sa marque sont la
					propriété de Themelio Inc. Les articles agrégés restent
					la propriété de leurs éditeurs respectifs. Vigilio
					fournit des liens et métadonnées, pas le contenu intégral
					des articles.
				</p>

				<h2>6. Abonnement et facturation</h2>
				<ul>
					<li>
						Les tarifs et fonctionnalités de chaque plan sont
						décrits sur notre page de tarification
					</li>
					<li>
						Nous nous réservons le droit de modifier les tarifs
						avec un préavis de 30 jours
					</li>
				</ul>

				<h2>7. Résiliation</h2>
				<p>
					Vous pouvez supprimer votre compte à tout moment dans les
					paramètres. Nous pouvons suspendre 	ou résilier votre
					accès en cas de violation des présentes conditions, avec
					notification préalable sauf en cas d'urgence.
				</p>

				<h2>8. Limitation de responsabilité</h2>
				<p>
					Le Service est fourni « tel quel ». Nous ne garantissons
					pas l'exactitude, l'exhaustivité ou la disponibilité
					continue des données agrégées. Notre responsabilité est
					limitée au montant payé pour le Service au cours des 12
					derniers mois.
				</p>

				<h2>9. Loi applicable</h2>
				<p>
					Les présentes conditions sont régies par les lois du
					Québec et les lois fédérales du Canada applicables. Tout
					litige sera soumis aux tribunaux compétents du district
					judiciaire de Montréal.
				</p>

				<h2>10. Modifications</h2>
				<p>
					Nous pouvons modifier ces conditions. Les modifications
					importantes seront communiquées par courriel au moins 30
					jours avant leur entrée en vigueur.
				</p>

				<h2>11. Contact</h2>
				<p>
					Pour toute question :<br />
					Themelio Inc.
					<br />
					<a href="mailto:support@themelio.ca">
						support@themelio.ca
					</a>
				</p>
			</div>
		</div>
	)
}
